import React from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  createCustomPropType,
  isNumeric,
} from '../../../../js/app/react/validators';

import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_KEY,
  CHILDREN_CRUD_OVERVIEW,
  CHILDREN_CRUD_ADD_EDIT,
} from '../PersonalInfoWorkflowConstants';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import ChildrenAddEdit from './ChildrenAddEditContainer';
import childrenOverviewShouldSkip from './ChildrenOverviewShouldSkip';

const ChildrenOverviewView = ({
  branch,
  workflowId,
  clientId,
  hasChildren,
  children,
  isEmptyState,
  alreadyHadChildrenData,
  store,
  store2,
  onAddChild,
  onEditChild,
  onRemoveChild,
  onPostSave,
  viewID,
  isGoingForward,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    canSkip={childrenOverviewShouldSkip(isGoingForward, hasChildren, children)}
    id="ChildrenOverview"
  >
    {viewID === CHILDREN_CRUD_OVERVIEW && (
      <div>
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.ChildrenOverview`} />
        <h2>
          {hasChildren && alreadyHadChildrenData
            ? 'Tell us about your children.'
            : 'What are their name and ages?'}
        </h2>
        <div className="adv-workflow-crud-widget">
          {isEmptyState ? (
            <div className="adv-workflow-crud-empty">
              <div className="adv-workflow-crud-empty-add">
                <button
                  className="adv-workflow-crud-empty-add-button"
                  type="button"
                  onClick={onAddChild(children, store(workflowId), store2(workflowId), clientId)}
                >
                  <i className="adv-workflow-crud-empty-add-button-i">+</i>
                  <br />
                  Add a new child
                </button>
              </div>
            </div>
          ) : (
            <div className="adv-workflow-crud-populated">
              <ul className="adv-workflow-crud-populated-ul">
                {children.map(({ FirstName, Age }, index) => (
                  <li className="adv-workflow-crud-populated-li">
                    <div className="adv-workflow-crud-populated-name">{FirstName}</div>
                    <div className="adv-workflow-crud-populated-value">{Age}</div>
                    <div className="adv-workflow-crud-populated-actions">
                      <button
                        type="button"
                        className="adv-workflow-crud-populated-action"
                        aria-label="edit child"
                        onClick={onEditChild(
                          children,
                          store(workflowId),
                          store2(workflowId),
                          index,
                          clientId,
                        )}
                      >
                        <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                      </button>
                      <button
                        type="button"
                        className="adv-workflow-crud-populated-action"
                        aria-label="remove child"
                        onClick={onRemoveChild(children, store(workflowId), index, clientId)}
                      >
                        <i className="adv-workflow-crud-populated-action-i far fa-trash-alt" />
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="adv-workflow-crud-populated-add">
                <button
                  className="adv-workflow-crud-populated-add-button"
                  onClick={onAddChild(children, store(workflowId), store2(workflowId), clientId)}
                  type="button"
                >
                  <i className="adv-workflow-crud-populated-add-button-i">+</i>
                  Add a new child
                </button>
              </div>
            </div>
          )}
        </div>
        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          workflowId={workflowId}
          backendKey={BACKEND_KEY}
          validationId={`${BACKEND_KEY}.ChildrenOverview`}
          onPostSave={onPostSave(store2(workflowId), clientId)}
          validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'children_info_completed')}
        />
      </div>
    )}
    {viewID === CHILDREN_CRUD_ADD_EDIT && <ChildrenAddEdit workflowId={workflowId} />}
  </AdvWorkflowStep>
);

ChildrenOverviewView.defaultProps = {
  hasChildren: false,
};

ChildrenOverviewView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store2: PropTypes.func.isRequired,
  isEmptyState: PropTypes.bool.isRequired,
  store: PropTypes.func.isRequired,
  hasChildren: PropTypes.bool,
  children: PropTypes.arrayOf(
    PropTypes.shape({
      FirstName: createCustomPropType(isNonEmptyString).isRequired,
      Age: createCustomPropType(isNumeric).isRequired,
    }),
  ).isRequired,
  onAddChild: PropTypes.func.isRequired,
  onEditChild: PropTypes.func.isRequired,
  alreadyHadChildrenData: PropTypes.bool.isRequired,
  onRemoveChild: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  viewID: PropTypes.oneOf([CHILDREN_CRUD_ADD_EDIT, CHILDREN_CRUD_OVERVIEW]).isRequired,
  isGoingForward: PropTypes.bool.isRequired,
};

export default ChildrenOverviewView;
